import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { LiveClassLessonTrack } from '../../../live-class-lesson-track-dto';

@Component({
  selector: 'lp2-private-class-header',
  template: `
    <div class="header w-100 text-center mt-3 mt-lg-2">
      <div class="d-flex align-items-center justify-content-center justify-content-xl-start">
        <p class="d-flex align-items-center mx-1 mx-lg-0 mr-lg-1 fs-5 lh-4 fw-bold">
          <span class="track-name mr-2">{{ 'pc_revamp.' + track.uuid + '.name' | translate }}</span>
          <span *ngIf="tag" class="level-tag d-none d-lg-inline-block mr-lg-3">
            {{ tag | translate | uppercase }}
          </span>
        </p>
      </div>
      <span *ngIf="tag" class="level-tag d-inline-block d-lg-none">{{ tag | translate | uppercase }}</span>
    </div>
  `,
  styleUrls: ['./private-class-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivateClassHeaderComponent {
  @Input() tag: string;
  @Input() track: LiveClassLessonTrack;
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/private-class-banner/private-class-left-header-banner/private-class-header/private-class-header.component.ts